__turbopack_context__.v({
  "blocksBackgroundColor": "BlockTypeFilters-module-scss-module__uWyKyG__blocksBackgroundColor",
  "blocksFontColor": "BlockTypeFilters-module-scss-module__uWyKyG__blocksFontColor",
  "filterList": "BlockTypeFilters-module-scss-module__uWyKyG__filterList",
  "secondaryNavBackgroundColor": "BlockTypeFilters-module-scss-module__uWyKyG__secondaryNavBackgroundColor",
  "themeBackgroundColor": "BlockTypeFilters-module-scss-module__uWyKyG__themeBackgroundColor",
  "themeFontColor": "BlockTypeFilters-module-scss-module__uWyKyG__themeFontColor",
  "themeFontFamily": "BlockTypeFilters-module-scss-module__uWyKyG__themeFontFamily",
  "xsOnlyBreak": "BlockTypeFilters-module-scss-module__uWyKyG__xsOnlyBreak",
});
